/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useTour } from "@reactour/tour";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Keyboard, Navigation, Grid } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/grid";
import "swiper/css";

/* 🧩 COMPONENTS */
import { Modal, Button, Breadcrumb,} from "../../../Components";
import { Bardays, CardBar, CardBig, Months, CalendarMonth, DonutGraph3D } from "../Components";


/* 🔗 SERVICE */
import { ControlePerdasService } from "../../../Services/dashboardServices/controlePerdas";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";
import { store } from "../../../Redux/Store";
import { ChangeLossControlDay, ChangeLossControlMonth, changeModal, ChangeLossControlyear, ChangeLossControlMode} from "../../../Redux/Actions";

/* 📁 ASSETS*/
import  Calendario  from "../../../Assets/icons/Calendar.svg";
import { RelogioIcon, Ajuda } from "../../../Assets/icons";
import { ReportIcon } from "../../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, Header, ContainerSelect, ContainerTop, ContainerCardsSlim,
    ContainerCardsSlimMobile, ContainerBottom, ContainerBottomMobile, StateMonthText, StateContainer, SwiperMobileStyles, 
    CardsLoader, LastUpdateText, LastUpdateIcon, StateText, SwiperStyles, SearchInput,  LastUpdateContainer, ImageIcon, 
    HeaderContainer, ContainerDonut} from "./styles";
import { HelpIcon } from "../../styles";

/* 🔧 UTILS */
import { getDataString, getLastDay } from "../../../util/Months";

const DashboardControlePerdas = () => {
    
    const { t, i18n } = useTranslation();
    document.title = t("dashboards.document-title");

    const navigationFlow =  [
        { text: 'dashboard', page: null },
        { text: 'loss-control', page: null },
    ]
    
    const { isOpen, currentStep } = useTour();

    
    const controlePerdasService = useRef(new ControlePerdasService());
    const swiperRefWeb = useRef(null);
    const swiperRefMobile = useRef(null);


    const day = useSelector(state => state.DashboardControlePerdasReducer.day);
    const days = useSelector(state => state.DashboardControlePerdasReducer.days);
    const month = useSelector(state => state.DashboardControlePerdasReducer.month);
    const year = useSelector(state => state.DashboardControlePerdasReducer.year);
    const cards = useSelector(state => state.DashboardControlePerdasReducer.cards);
    
    const name = useSelector(state => state.DashboardControlePerdasReducer.name);
    const Mode = useSelector(state => state.DashboardControlePerdasReducer.Mode);

    const isLoadingCards = useSelector(state => state.DashboardControlePerdasReducer.isLoadingCards);
    const isLoadingDays = useSelector(state => state.DashboardControlePerdasReducer.isLoadingDays);

    const isAutoplayEnabled = useSelector(state => state.DashboardControlePerdasReducer.isAutoplayEnabled);

    const TimeReset = getDataString(new Date().getHours()) + ' h ' + getDataString(new Date().getMinutes()) + ' min';

    const [searchItem, setSearchItem] = useState('');

    // const [searchCards, setSearchCards] = useState('');

    console.log('cards', cards)

    const [currentDate, setCurrentDate] = useState(new Date());

    // // Cards visíveis filtrados
    // const visibleCards = searchItem && searchItem.length > 0 ? cards[1] : cards[0];


    // const visibleCards = searchItem && searchItem.length > 0 ? cards : cards;


    const appliedDate = new Date(year, month - 1, day);

    useEffect(() => {
        if (!day || !month || !year) return;

        const dayStr = getDataString(day);
        const monthStr = getDataString(month);

        controlePerdasService.current.changeMonthYear(
            dayStr,
            monthStr,
            year
        );
    }, []);

    // Texto do calendário baseado diretamente no Redux
    const calendarText = (() => {
        if (!day || !month || !year) return "";

        const monthText = new Date(year, month - 1, day)
            .toLocaleDateString(i18n.language, { month: "long" })
            .replace(/^./, (c) => c.toUpperCase());

        return `${monthText}/${year}`;
    })();

    useEffect(() => {   
        swiperRefWeb.current?.autoplay.stop();
        swiperRefMobile.current?.autoplay.stop();
    }, [isAutoplayEnabled]);

    // const handleTour = () => {
    //     if (!equipamento || !cards[0][0].Active) {
    //         toast(t("message.dashboards.handle-tour"), {
    //             position: "top-center",
    //             type: 'info',
    //             autoClose: 3000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: false,
    //             draggable: false,
    //             progress: undefined,
    //         });
    //     } else {
    //         setIsOpen(true);
    //     }
    // }

    const dataDonutTotal = useSelector(state => state.DashboardControlePerdasReducer.donutGraphTotal);
    const dataDonut = useSelector(state => state.DashboardControlePerdasReducer.donutGraph);

    const colorsGraph =  {
        "loss": "#3E73A8",
        "consumption": "#55965E",
        "production": "#006560",
    }

    const dataDonutGraph3D = dataDonut.map(item => ({
        ...item,
        label: t(`dashboards.sub-items.loss-control.graphic.parameters.${item.label}`),
        color: colorsGraph[item.label] || '#FFFFFF',
    }));



    return (
        <>
            <Container $isTourOpen={isOpen}>
                <Header>
                    <Breadcrumb flow={navigationFlow}/>
                    <LastUpdateContainer>
                        <div className="date-time">
                            <LastUpdateText>{t("control.date", { date: currentDate, format: "dayMonth" })}</LastUpdateText>
                            <LastUpdateText> <LastUpdateIcon src={RelogioIcon}/> {TimeReset} </LastUpdateText>
                        </div>
                        <Button  icon={<HelpIcon src={Ajuda} className={"icon"} $disabled={true} />} disabled={true} padding={"8px 10px"} radius={"3px"} width={"44px"}/>{/* onClick={() => handleTour()} disabled={isLoadingCards}*/}
                    </LastUpdateContainer>
                </Header>
                <ContainerSelect>
                    <div className="selects">
                        <HeaderContainer id="date-inputs">
                            <div>
                                <Button icon={<ImageIcon src={Calendario}/>} color={'white-green'} text={calendarText} onClick={() => store.dispatch(changeModal('calendar-month'))}/>
                            </div>
                        </HeaderContainer>
                        
                    </div>
                    <div className="report-buttons-container">
                        <Button text={t("buttons.reports")} id={"reports-button"} disabled={true} icon={<ImageIcon src={ReportIcon} fill={(isOpen && currentStep === 0) && 'disabled'}/>} padding={'14px'} onClick={() => store.dispatch(changeModal('reports'))}/>
                    </div>
                </ContainerSelect>


                    <StateText> {t("dashboards.sub-items.loss-control.header-title")} </StateText>

                
                <ContainerTop>
                    <ContainerCardsSlim>
                        <SearchInput
                            id="search-card"
                            aria-label={t("inputs.search-card.alt")}
                            type="text"
                            placeholder={t("inputs.search-card.placeholder")} 
                            value={searchItem}
                            disabled={isLoadingCards || (isOpen && currentStep === 12)}
                            onChange={(e) => {
                                setSearchItem(e.target.value);
                                controlePerdasService.current.FilterCards(e.target.value)
                            }}
                        />
                        {isLoadingCards ?
                            <CardsLoader>
                                {[1, 2, 3, 4].map((_, index) => (
                                    <CardBig key={index} Active={false} isLoading={isLoadingCards}/>
                                ))}
                            </CardsLoader>
                        : cards.length > 0 &&
                            <Swiper
                                // ()=> swiperRef.current?.autoplay.start()
                                id="swiper"
                                ref={swiperRefWeb}
                                onSwiper={swiper => swiperRefWeb.current = swiper}
                                onResize={(swiper) => {swiper.update()}}
                                style={SwiperStyles}
                                grid={{rows: 2}}
                                slidesPerView={2}
                                grabCursor={true}
                                modules={[Autoplay, Grid, Pagination, Keyboard, Navigation]}
                                pagination={{ clickable: true }}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                keyboard={{enabled: true}}
                                autoplay={{delay: 5000, disableOnInteraction: true, pauseOnMouseEnter: true}}
                                >
                                {cards?.map((card, index) => (
                                    <SwiperSlide key={index} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <CardBig key={index} index={index} Bar={<CardBar valor={card['campo%']?.valor} Color={6} />} 
                                            Title={card?.name} Color={6} Active={card.Active !== false} Focus={card.focus} valor={card?.production} 
                                            hasMore = {false} isLoading={isLoadingCards}
                                            porcentagem={card['campo%']?.valor} unidade={card?.unit}
                                            onClick={() => {
                                                if (!card.focus) {
                                                    controlePerdasService.current.changeFocus(
                                                        card?.id,
                                                        index,
                                                        card.key,
                                                        card.idEquipment
                                                    );
                                                }
                                            }}
                                            notFixed={true}
                                        />
                                    </SwiperSlide>
                                ))}
                                <div className="swiper-button-next" style={{ display: 'block', right: 0, top: '200px'}}></div>
                                <div className="swiper-button-prev" style={{ display: 'block', left: 0, top: '200px'}}></div>
                            </Swiper>
                        } 
                    </ContainerCardsSlim>
                    <ContainerDonut>
                        <StateText> {t("dashboards.sub-items.loss-control.graphic-title")} </StateText>
                        <DonutGraph3D data={dataDonutGraph3D} dataTotal={dataDonutTotal}/>
                    </ContainerDonut>

                    
                </ContainerTop>

                
                <ContainerCardsSlimMobile>
                    <SearchInput
                        id="search-card-mobile" 
                        aria-label={t("inputs.search-card.alt")}
                        type="text"
                        placeholder={t("inputs.search-card.placeholder")}
                        value={searchItem}
                        onChange={(e) => {
                            setSearchItem(e.target.value);
                            controlePerdasService.current.FilterCards(e.target.value)
                        }}
                    />
                    {isLoadingCards ?
                            [1, 2, 3, 4].map((_, index) => (
                                <CardBig key={index} Active={false} isLoading={isLoadingCards}/>
                            ))
                        :
                            cards.length > 0 &&
                            <Swiper
                                id="swiper-mobile"
                                ref={swiperRefMobile}
                                onSwiper={swiper => swiperRefMobile.current = swiper}
                                onResize={(swiper) => swiper.update()}
                                style={SwiperMobileStyles}
                                grid={{
                                    rows: 1,
                                }}
                                slidesPerView={3}
                                grabCursor={true}
                                modules={[Autoplay, Pagination, Keyboard, Navigation, Grid]}
                                pagination={{clickable: true}}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                keyboard={{enabled: true}}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: true,
                                }}
                                >

                                {cards.map((card, index) => (
                                        <SwiperSlide
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <CardBig
                                                index={index}
                                                Bar={
                                                    <CardBar
                                                        valor={card['campo%']?.valor}
                                                        Color={6}
                                                    />
                                                }
                                                Title={card?.name}
                                                Color={6}
                                                Active={true}
                                                Focus={card.focus}
                                                valor={card?.production}
                                                hasMore={false}
                                                isLoading={isLoadingCards}
                                                porcentagem={card['campo%']?.valor}
                                                unidade={card?.unit}
                                                onClick={() => {
                                                    if (!card.focus) {
                                                        controlePerdasService.current.changeFocus(
                                                            card?.id,
                                                            index,
                                                            card.key,
                                                            card.idEquipment
                                                        );
                                                    }
                                                }} 
                                                notFixed={true}
                                            />
                                        </SwiperSlide>
                                    ))}
                                <div className="swiper-button-next" style={{ display: 'block', top:'100px', right:0 }}></div>
                                <div className="swiper-button-prev" style={{ display: 'block', top:'100px', left: 0 }}></div>
                            </Swiper>
                        }
                </ContainerCardsSlimMobile>

                <ContainerBottomMobile id="bardays-landscape">
                    <StateContainer>
                        <StateMonthText> 
                            {name} 
                        </StateMonthText>
                    </StateContainer>

                    <Bardays month={month} year={year} days={days} day={day} 
                        type={'graph'}
                        Mode={parseInt(Mode)}
                        CardStatus={7}
                        isLoading={isLoadingDays}
                        ChangeDays={(currentday) => {
                            store.dispatch(ChangeLossControlDay(currentday))
                            controlePerdasService.current.changeDay(currentday, month, year)
                        }}/>
                    
                    <Months 
                        id={"today-button-landscape"}
                        CardStatus={7}
                        disabled={ isLoadingDays}
                        ChangeDays={(currentday) => {
                            store.dispatch(ChangeLossControlDay(currentday))
                            controlePerdasService.current.changeDay(currentday, month, year)
                        }}
                        ChangeMonths={(currentmonth) => {
                            store.dispatch(ChangeLossControlMonth(currentmonth));
                            store.dispatch(ChangeLossControlDay(getLastDay(currentmonth, year)));
                            controlePerdasService.current.changeMonthYear(getLastDay(currentmonth, year), currentmonth, year);
                        }}
                        ChangeMode={(mode) => {
                            store.dispatch(ChangeLossControlMode(mode))
                            controlePerdasService.current.getHoursData();
                        }}
                        showDayButton={parseInt(day) !== new Date().getDate() ||
                            parseInt(month) !== new Date().getMonth()+1 || 
                            parseInt(year) !== new Date().getFullYear()}
                        BackToday={() => {
                            controlePerdasService.current.changeMonthYear(getDataString(new Date().getDate()), getDataString(new Date().getMonth()+1), new Date().getFullYear())
                            store.dispatch(ChangeLossControlDay(getDataString(new Date().getDate())))
                            store.dispatch(ChangeLossControlMonth(getDataString(new Date().getMonth()+1)))
                            store.dispatch(ChangeLossControlyear(new Date().getFullYear()))
                        }}
                        currentmonth={parseInt(month)-1}
                        year={year}
                        Changeyear={(currentyear) => {
                            store.dispatch(ChangeLossControlyear(currentyear))
                            controlePerdasService.current.changeMonthYear(day, month, currentyear)
                        }}
                    />
                </ContainerBottomMobile>
                
                
                <ContainerBottom id="bardays">
                    <StateContainer>
                        <StateMonthText> 
                            {name} 
                        </StateMonthText>
                    </StateContainer>

                    <Bardays month={month} year={year} days={days} day={day} 
                    type={'graph'}
                    Mode={parseInt(Mode)}
                    CardStatus={7}
                    colorArea = {true}
                    isLoading={isLoadingDays}
                    disabled={false}
                    ChangeDays={(currentday) => {
                        store.dispatch(ChangeLossControlDay(currentday))
                        controlePerdasService.current.changeDay(currentday, month, year)
                    }}/>
                    <Months 
                        id={"today-button"}
                        CardStatus={7}
                        disabled={ isLoadingDays}
                        ChangeDays={(currentday) => {
                            store.dispatch(ChangeLossControlDay(currentday))
                            controlePerdasService.current.changeDay(currentday, month, year)
                        }}
                        ChangeMonths={(currentmonth) => {
                            store.dispatch(ChangeLossControlMonth(currentmonth));
                            store.dispatch(ChangeLossControlDay(getLastDay(currentmonth, year)));
                            controlePerdasService.current.changeMonthYear(getLastDay(currentmonth, year), currentmonth, year);
                        }}
                        showDayButton={parseInt(day) !== new Date().getDate() || 
                            parseInt(month) !== new Date().getMonth() + 1 || 
                            parseInt(year) !== new Date().getFullYear()}
                        BackToday={() => {
                            let date = new Date();
                            setCurrentDate(date);
                            controlePerdasService.current.changeMonthYear(getDataString(date.getDate()), getDataString(date.getMonth() + 1), date.getFullYear());
                            store.dispatch(ChangeLossControlDay(getDataString(date.getDate())));
                            store.dispatch(ChangeLossControlMonth(getDataString(date.getMonth() + 1)));
                            store.dispatch(ChangeLossControlyear(date.getFullYear()));
                        }}
                        ChangeMode={(mode) => {
                            store.dispatch(ChangeLossControlMode(mode));
                            controlePerdasService.current.getHoursData();
                        }}
                        currentmonth={parseInt(month) - 1}
                        year={year}
                        Changeyear={(currentyear) => {
                            store.dispatch(ChangeLossControlyear(currentyear));
                            controlePerdasService.current.changeMonthYear(day, month, currentyear);
                        }}
                    />
                </ContainerBottom>

            </Container>
                
            <Modal name={'calendar-month'} width={'20%'} height={'55%'}>
                <CalendarMonth
                    container="popup"
                    selectedDate={appliedDate}
                />
            </Modal>


        </>
    );
}

export default DashboardControlePerdas;
